export const REPORT_NAMES = [
  'EFFICIENCY_AND_IDLING_TREND',
  'EFFICIENCY_PROGRESS',
  'IDLING_TRACKER',
  'IDLING_PERFORMANCE',
  'VEHICLE_SPEED_TREND',
  'ENGINE_SPEED_TREND',
];

export const DEF_SEARCH_PARAM_FE = {
  vehicleIds: [],
  reportNames: REPORT_NAMES,
  groupNames: [],
};
